<template>
  <div>
    <div v-if="noSignalDate">
      <div>
        <i class="mdi mdi-alert pr-2"></i>
        {{ $t('box.noConnection') }}
      </div>
      <p class="text-muted small-text">с {{ noSignalCaption }}</p>
    </div>
    <div v-else class="mt-1 d-inline-flex align-items-end" style="width: 31px; height: 15px">
      <div class="h-25 border border-white rounded" :class="[bgLogic(0)]" style="width: 18%"></div>
      <div
        class="h-50 border border-white rounded"
        :class="[bgLogic(25)]"
        style="width: 18%; margin-left: 2px"
      ></div>
      <div
        class="h-75 border border-white rounded"
        :class="[bgLogic(50)]"
        style="width: 18%; margin-left: 2px; margin-right: 2px"
      ></div>
      <div
        class="h-100 border border-white rounded"
        :class="[bgLogic(75)]"
        style="width: 18%; margin-left: 1px; background: transparent"
      ></div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  name: 'BoxInfoConnection',
  props: {
    value: Number,
    noSignalDate: String,
  },
  computed: {
    noSignalCaption() {
      return this.noSignalDate ? moment(this.noSignalDate).format('DD.MM.YYYY HH:mm:ss') : null;
    },
  },
  methods: {
    bgLogic(con) {
      return this.value && this.value > con ? 'bg-white' : 'bg-transparent';
    },
  },
};
</script>

<style></style>
